import { Component, Input, inject } from '@angular/core';
import { ThemesWrapperComponent } from "../themes-wrapper/themes-wrapper.component";
import { NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-carte-atelier',
  imports: [ThemesWrapperComponent, NgStyle, RouterLink],
  templateUrl: './carte-atelier.component.html',
  styleUrl: './carte-atelier.component.scss'
})
export class CarteAtelierComponent {
  @Input() atelier: any;
  randomRotation: number = (Math.random() - 0.5) * 10;
  
  private apiService = inject(ApiService);

  getImageUrl(url: string): string {
    return this.apiService.getImageUrl(url);
  }
}
